import moment from "moment";
export default class DateManipulationService {

  constructor() {
    this.FORMAT_DATETIME = 'YYYY-MM-DD HH:mm:ss'; // `z` would be nice, but need moment-timezone for it to be reliable
    this.ISO_FORMAT_DATETIME = 'YYYY-MM-DDTHH:mm:ss';
    this.FORMAT_DATE = 'YYYY-MM-DD';
  }

  convertToMomentIfNotAlready(date) {
    if (!moment.isMoment(date)) {
      return moment(date);
    } else {
      return date
    }
  }

  formatDatetime(date) {
    let m = this.convertToMomentIfNotAlready(date)
    m = m.local();  // convert pre-existing moment objects to local match behavior of moment(input)
    return m.format(this.FORMAT_DATETIME);
  }

  formatIsoDatetime(date) {
    let m = this.convertToMomentIfNotAlready(date)
    m = m.local();  // convert pre-existing moment objects to local match behavior of moment(input)
    return m.format(this.ISO_FORMAT_DATETIME);
  }

  isoDate(date) {
    let m = this.convertToMomentIfNotAlready(date);
    return m.format(this.FORMAT_DATE);
  }

  createFormattedStartAndEndDateFromToday(daysBack) {
    let startTime = moment().format('YYYY-MM-DD')
    let startTimeMidNight = moment(startTime, 'YYYY-MM-DD').format('YYYY-MM-DD hh:mm A')
    let startTimeEndOfDay = moment(startTimeMidNight, 'YYYY-MM-DD hh:mm A').add(1, 'day').subtract(60, 'seconds').format('YYYY-MM-DD hh:mm A')

    let endTime = moment().subtract(daysBack, 'days').format('YYYY-MM-DD')
    let endTimeMidNight = moment(endTime, 'YYYY-MM-DD').format('YYYY-MM-DD hh:mm A')

    return [endTimeMidNight, startTimeEndOfDay]
  }

  generateLocalFromUTC(UTCTime) {
    let localTime = moment.utc(UTCTime).toDate();
    return moment(localTime).format('YYYY-MM-DD hh:mm:ss A');
  };

  utcFormattedString(UTCTime) {
    return moment.utc(UTCTime).format('YYYY-MM-DD HH:mm:ss');
  }
}
